/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  PlayerRewardStatus,
  PlayerRewardsPage,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PlayerRewardStatusFromJSON,
    PlayerRewardStatusToJSON,
    PlayerRewardsPageFromJSON,
    PlayerRewardsPageToJSON,
} from '../models/index';

export interface GetRewardsForPlayerRequest {
    playerLookupId: string;
    customerId: string;
    resultStart: number;
    resultEnd: number;
    statuses?: Array<PlayerRewardStatus>;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class PlayerRewardsApi extends runtime.BaseAPI {

    /**
     * Return a paginated list of a player\'s rewards, optionally filtered by status
     */
    async getRewardsForPlayerRaw(requestParameters: GetRewardsForPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlayerRewardsPage>> {
        if (requestParameters['playerLookupId'] == null) {
            throw new runtime.RequiredError(
                'playerLookupId',
                'Required parameter "playerLookupId" was null or undefined when calling getRewardsForPlayer().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getRewardsForPlayer().'
            );
        }

        if (requestParameters['resultStart'] == null) {
            throw new runtime.RequiredError(
                'resultStart',
                'Required parameter "resultStart" was null or undefined when calling getRewardsForPlayer().'
            );
        }

        if (requestParameters['resultEnd'] == null) {
            throw new runtime.RequiredError(
                'resultEnd',
                'Required parameter "resultEnd" was null or undefined when calling getRewardsForPlayer().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['resultStart'] != null) {
            queryParameters['resultStart'] = requestParameters['resultStart'];
        }

        if (requestParameters['resultEnd'] != null) {
            queryParameters['resultEnd'] = requestParameters['resultEnd'];
        }

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:player-rewards"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/player-rewards/player/{playerLookupId}`;
        urlPath = urlPath.replace(`{${"playerLookupId"}}`, encodeURIComponent(String(requestParameters['playerLookupId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayerRewardsPageFromJSON(jsonValue));
    }

    /**
     * Return a paginated list of a player\'s rewards, optionally filtered by status
     */
    async getRewardsForPlayer(requestParameters: GetRewardsForPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlayerRewardsPage> {
        const response = await this.getRewardsForPlayerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
